import MaterialTable from 'material-table';
import React, { Component } from 'react';
import { CENTRALIZED_LOGGER_CUSTOMER } from '../constants/ApiEndpoints';
import { makeGetRequest } from '../helpers/biztechAxiosRequest';
import moment from 'moment';
import { DD_MMM_YYYY_HH_MM_SS_A_Z } from '../constants/DateTimeFormats';

export default class CustomerAccountLogTable extends Component {
  formatTimeStamp(logs: any[]): any {
    const formattedData = logs.map(log => {
      log.senderTimestamp = moment(log.senderTimestamp).format(
        DD_MMM_YYYY_HH_MM_SS_A_Z
      );
      return log;
    });
    return formattedData;
  }

  render() {
    const customerAccountId = (this.props as any).customerAccountId;
    return (
      <MaterialTable
        title="Recent Activities"
        columns={[
          {
            title: 'Category',
            field: 'category',
            grouping: false,
            sorting: false,
            render: (rowData: any) => (
              <a
                href={`#/logs/correlation/${rowData.correlationId}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: 'none' }}
              >
                {rowData.category}
              </a>
            )
          },
          {
            title: 'Process',
            field: 'process',
            sorting: false
          },
          { title: 'Performed By', field: 'performedBy', sorting: false },
          {
            title: 'Date Time',
            field: 'senderTimestamp',
            width: '30%'
          }
        ]}
        data={query =>
          new Promise((resolve, reject) => {
            const centralizedLogURL = `${CENTRALIZED_LOGGER_CUSTOMER}/${customerAccountId}/?pageno=${query.page +
              1}&pagesize=${query.pageSize}`;
            makeGetRequest(centralizedLogURL)
              .then((result: any) => {
                resolve({
                  data: this.formatTimeStamp(result.data.data.customerLogs),
                  page: query.page,
                  totalCount: result.data.data.totalRecordCount
                });
              })
              .catch(error => {
                console.log(error);
                reject();
              });
          })
        }
        options={{
          search: false,
          grouping: true,
          sorting: true
        }}
      />
    );
  }
}
